const getCurrentEnvironment = () => {
  let env = "development";

  if (process.env.REACT_APP_ENV === "local") {
    env = "local";
  } else if (process.env.REACT_APP_ENV === "dev") {
    env = "dev";
  } else if (process.env.REACT_APP_ENV === "stg") {
    env = "stg";
  } else if (process.env.REACT_APP_ENV === "prod") {
    env = "prod";
  }
  return env;
};
type EnvironmentType = {
  readonly apiBaseUrl: string;
  readonly socketUrl: string;
  readonly PUSHER_APP_KEY: string;
  readonly PUSHER_APP_CLUSTER: string;
};

type EnvironmentsType = {
  readonly development: EnvironmentType;
  readonly local: EnvironmentType;
  readonly stg: EnvironmentType;
  readonly dev: EnvironmentType;
  readonly prod: EnvironmentType;
};

export const Environments: EnvironmentsType = {
  local: {
    apiBaseUrl: `http://localhost:3000`,
    socketUrl: "wss://api-simpsocial-dev.tkxel-team/cable",
    PUSHER_APP_KEY: "1a907ff1c41b7c1bb8b8",
    PUSHER_APP_CLUSTER: "ap2",
  },
  development: {
    apiBaseUrl: `https://api.simpsocial-dev.com`,
    socketUrl: "wss://api.simpsocial-dev.com/cable",
    PUSHER_APP_KEY: "1a907ff1c41b7c1bb8b8",
    PUSHER_APP_CLUSTER: "ap2",
  },
  stg: {
    apiBaseUrl: `https://api.staging.simpsocial-dev.com`,
    socketUrl: "wss://api.staging.simpsocial-dev.com/cable",
    PUSHER_APP_KEY: "1a907ff1c41b7c1bb8b8",
    PUSHER_APP_CLUSTER: "ap2",
  },
  dev: {
    apiBaseUrl: `https://api.simpsocial-dev.com`,
    socketUrl: "wss://api.simpsocial-dev.com/cable",
    PUSHER_APP_KEY: "1a907ff1c41b7c1bb8b8",
    PUSHER_APP_CLUSTER: "ap2",
  },
  prod: {
    apiBaseUrl: `https://api.gocrm.ai`,
    socketUrl: "wss://api.gocrm.ai/cable",
    PUSHER_APP_KEY: "12de55df91e02bba9ec1",
    PUSHER_APP_CLUSTER: "mt1",
  },
} as const;

export const SERVICES = {
  apiBaseUrl: (Environments as any)[getCurrentEnvironment()].apiBaseUrl,
  socketUrl: (Environments as any)[getCurrentEnvironment()].socketUrl,
   PUSHER_APP_KEY: (Environments as any)[getCurrentEnvironment()]. PUSHER_APP_KEY,
  PUSHER_APP_CLUSTER: (Environments as any)[getCurrentEnvironment()].PUSHER_APP_CLUSTER,

};
